
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared/t/[id]",
      function () {
        return require("private-next-pages/shared/t/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared/t/[id]"])
      });
    }
  